import { GetStaticProps, GetStaticPaths } from 'next';
import { getTotalPostCount } from '@api';
import Page from '../../category/[slug]/page/[pageNo]';
import { getStaticPropsCore } from '@/src/getStatic/categoryGetStaticPropsCore';
import { calcPageCountFromPostCount } from '@utils';

export default Page;

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { pageNo: string }>>[0]) => {
  console.info(`getStaticProps /interview`);
  return await getStaticPropsCore('interview', { pageNo: params?.pageNo });
};

export const getStaticPaths: GetStaticPaths<{ pageNo: string }> = async () => {
  const postCount = (await getTotalPostCount('interview')) || 0;

  return {
    paths: Array(calcPageCountFromPostCount(postCount))
      .fill(0)
      .map((_, i) => ({
        params: { pageNo: String(i + 1) },
      })),
    fallback: 'blocking',
  };
};
